import { component } from 'picoapp'
import { zelektor, loopify, toggleDisplay } from '@/lib/utility-functions.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { blockTitle: blockTitles, blockContent: blockContents, moreBtn, seoHidden } = zelektor(node)
    const gender = localStorage.getItem('spreeglee_gender') || 'unisex'

    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    loopify(blockTitles).forEach((t) => {
        t.addEventListener('click', clickBlockTitle)
    })

    if (moreBtn) {
        moreBtn.addEventListener('click', toggleSeoHidden)
    }

    ctx.on('gender:set', ({ gender }) => {
        setGender(gender)
    })

    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    init()

    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function init() {
        if (gender) setGender(gender)
    }

    function clickBlockTitle(e) {
        const thisTitle = e.currentTarget
        const { title } = thisTitle.dataset
        const thisContent = loopify(blockContents).find((c) => c.dataset.title === title)

        thisTitle.classList.toggle('is-open')
        thisContent.classList.toggle('is-open')
    }

    function toggleSeoHidden() {
        moreBtn.classList.toggle('is-open')

        const { showMore, showLess } = window.theme.strings.footer
        moreBtn.classList.contains('is-open') ? (moreBtn.innerText = showLess) : (moreBtn.innerText = showMore)

        toggleDisplay(seoHidden)
    }

    function setGender(gender) {
        node.classList.remove('gender--women')
        node.classList.remove('gender--men')
        node.classList.remove('gender--unisex')

        node.classList.add(`gender--${gender}`)
    }
})
